/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetConfig200Response
 */
export interface GetConfig200Response {
    /**
     * 
     * @type {string}
     * @memberof GetConfig200Response
     */
    qrMode: GetConfig200ResponseQrModeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetConfig200Response
     */
    qrPayLater: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetConfig200Response
     */
    qrMinimumBasket: number;
}


/**
 * @export
 */
export const GetConfig200ResponseQrModeEnum = {
    Menu: 'menu',
    Ordering: 'ordering',
    Payment: 'payment'
} as const;
export type GetConfig200ResponseQrModeEnum = typeof GetConfig200ResponseQrModeEnum[keyof typeof GetConfig200ResponseQrModeEnum];


/**
 * Check if a given object implements the GetConfig200Response interface.
 */
export function instanceOfGetConfig200Response(value: object): value is GetConfig200Response {
    if (!('qrMode' in value) || value['qrMode'] === undefined) return false;
    if (!('qrPayLater' in value) || value['qrPayLater'] === undefined) return false;
    if (!('qrMinimumBasket' in value) || value['qrMinimumBasket'] === undefined) return false;
    return true;
}

export function GetConfig200ResponseFromJSON(json: any): GetConfig200Response {
    return GetConfig200ResponseFromJSONTyped(json, false);
}

export function GetConfig200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetConfig200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'qrMode': json['qrMode'],
        'qrPayLater': json['qrPayLater'],
        'qrMinimumBasket': json['qrMinimumBasket'],
    };
}

export function GetConfig200ResponseToJSON(json: any): GetConfig200Response {
    return GetConfig200ResponseToJSONTyped(json, false);
}

export function GetConfig200ResponseToJSONTyped(value?: GetConfig200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'qrMode': value['qrMode'],
        'qrPayLater': value['qrPayLater'],
        'qrMinimumBasket': value['qrMinimumBasket'],
    };
}

